import './App.css';

import { Container, Row } from 'react-bootstrap';
import React, { useContext } from 'react';

import { AccessGroupsContext } from '../../../../components/app/App';
import ContactIdForm from '../contact-id-form/ContactIdForm';
import ManualTextForm from '../manual-text-form/ManualTextForm';
import PiiNotice from '../pii-notice/PiiNotice';
import { CONTACT_LOOKUP_ACCESS } from '../../../../global/app-global-values';

const App = () => {
  const accessGroups = useContext(AccessGroupsContext);

  return (
    <Container fluid className="w-100 p-0 m-0">
      <Container fluid className="app-content pt-2 pb-3">
        <h4 className="m-2 mb-3">
          <b>Luminous App</b>
        </h4>
        <Row hidden={!accessGroups.includes(CONTACT_LOOKUP_ACCESS)}>
          <Container fluid className="m-2 mb-3">
            <PiiNotice />
          </Container>
        </Row>
        <Row hidden={!accessGroups.includes(CONTACT_LOOKUP_ACCESS)}>
          <ContactIdForm />
        </Row>
        <Row>
          <Container fluid className="bordered mt-4 mr-4 ml-4 p-4 bg-white">
            <ManualTextForm />
          </Container>
        </Row>
      </Container>
    </Container>
  );
};

export default App;
